<template>
  <div>
     <div>Working Area</div>
     <div>
        <el-collapse v-model="activeProvince" accordion>
           <el-collapse-item
              v-for="state in states"
              :key="state.scode"
              :name="state.scode"
              >
              <template slot="title">
                 <div>{{ state.name }}
                    <el-checkbox :value="stateIsSelected(state)" @input="val => selectState(state, val)">Toggle all</el-checkbox>
                 </div>
              </template>
              <el-collapse v-model="activeDistrictCode" accordion>
                 <el-collapse-item
                    v-for="district in state.districts"
                    :key="district.dcode"
                    :name="district.dcode"
                    >
                    <template slot="title">
                       <div>{{ district.name }}
                          <el-checkbox :value="districtIsSelected(district)" @input="val => selectDistrict(district, val)">Toggle all</el-checkbox>
                       </div>
                    </template>
                    <el-checkbox
                       style="display: block;"
                       v-for="municipality in district.municipalities"
                       :key='municipality.sddmm'
                       v-model="municipality.checked"
                       @input="val => selectMunicipality(municipality, val)"
                       >
                       {{municipality.name}}
                    </el-checkbox>
                 </el-collapse-item>
              </el-collapse>
           </el-collapse-item>
        </el-collapse>
     </div>
  </div>
</template>

<script>
import { Checkbox,Collapse,CollapseItem } from 'element-ui';

export default {
   name: 'work-area-input',
   components: {
      'el-checkbox': Checkbox,
      'el-collapse': Collapse,
      'el-collapse-item': CollapseItem,
   },
   data()
   {
      return {
         activeDistrictCode: 0,
         activeProvince: 0,
      }
   },
   props: {
      states: {
         type: Array,
         required: true,
      },
      districtIsSelected: {
         type: Function,
         required: true,
      },
      stateIsSelected: {
         type: Function,
         required: true,
      },
      selectState: {
         type: Function,
         required: true,
      },
      selectDistrict: {
         type: Function,
         required: true,
      },
      selectMunicipality: {
         type: Function,
         required: true,
      },
   },
}
</script>

<style lang="scss">

</style>
